import { createContext } from 'react';
import type {
  HeaderContextValue,
  ContextSearchContextValue,
} from './interfaces';
import { GetAgentResourcesResponse } from '@trinity/chat';

export const HeaderContextContext = createContext<HeaderContextValue>(null);
export const ContextSearchContext = createContext<ContextSearchContextValue>(null);

export type AgentResourcesContextValue = {
  data: GetAgentResourcesResponse;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
};

export const AgentResourcesContext = createContext<AgentResourcesContextValue | null>(null);